import { render, staticRenderFns } from "./LoginPasswordNewFormDescription.vue?vue&type=template&id=5458f2b7&scoped=true&"
import script from "./LoginPasswordNewFormDescription.vue?vue&type=script&lang=js&"
export * from "./LoginPasswordNewFormDescription.vue?vue&type=script&lang=js&"
import style0 from "./LoginPasswordNewFormDescription.vue?vue&type=style&index=0&id=5458f2b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5458f2b7",
  null
  
)

/* custom blocks */
import block0 from "@/locales/login.locale.json?vue&type=custom&index=0&blockType=i18n&issuerPath=E%3A%5Capp%5CJenkins%5Cworkspace%5CAll_IaaS_Farm%5C0%20nextoreV3bdclient_build%5Csrc%5Csrc%5Cforms%5Clogin%5CLoginPasswordNewFormDescription.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports